import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackScreenView } from '../integrations/gtm';

const SCREEN_NAMES: Record<string, string> = {
  cadastro: 'cadastro',
  lojas: 'selecao_loja',
  datas: 'selecao_data',
  confirmacao: 'confirmacao_voucher',
  'consultar-voucher': 'consulta_voucher',
  'voucher-resgatado': 'voucher_resgatado',
};

let lastTrackedLocation = '';

export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const trackedLocation = `${location.pathname}${location.search}`;
    if (trackedLocation === lastTrackedLocation) return;

    lastTrackedLocation = trackedLocation;
    const routeSegments = location.pathname.split('/').filter(Boolean);
    const routeSegment = routeSegments[routeSegments.length - 1] || '';
    const screenName = SCREEN_NAMES[routeSegment] || (routeSegment ? 'campanha' : 'inicio');
    trackScreenView(screenName);
  }, [location.pathname, location.search]);

  return null;
}